export default "__VITE_ASSET__CwyJcFUE__"